module.exports = __webpack_public_path__ + "img/Duorol.673768d1.png";